import { render, staticRenderFns } from "./WidgetsTable.vue?vue&type=template&id=8b32b912"
import script from "./WidgetsTable.vue?vue&type=script&lang=js"
export * from "./WidgetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports